import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const QuoteApprovalInput = () => {
  const { approvalId = '' } = useParams();
  const decodedId = approvalId ? atob(approvalId) : approvalId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'quoteApproval';

  useEffect(() => {
    if (approvalId) { setIsEditing(true); fetchDetails(); }
  }, [approvalId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.quoteApproval}${id}/`, { headers });
      setFormData({
        ...response.data,
        quote: response.data.quote?.id ?? response.data.quote,
        approved_by: response.data.approved_by?.id ?? response.data.approved_by,
      });
    } catch (error) {
      console.error('Error fetching approval details:', error);
    }
  };

  const fields = [
    {
      name: 'quote', label: 'Quote', type: 'async-select',
      endpoint: API_ROUTES.quote,
      getOptionLabel: (q) => q.title || `Quote #${q.id}`,
    },
    {
      name: 'approved_by', label: 'Approved By', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    {
      name: 'status', label: 'Status', type: 'select',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'approved', label: 'Approved' },
        { value: 'rejected', label: 'Rejected' },
        { value: 'revision_requested', label: 'Revision Requested' },
      ],
    },
    { name: 'notes', label: 'Notes', type: 'textarea' },
    { name: 'rejection_reason', label: 'Rejection Reason', type: 'textarea' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Quote Approval' : 'Create Quote Approval'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default QuoteApprovalInput;
